<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-dark">
      <div class="container-fluid">
        <a class="navbar-brand">Avelica Bootstrap Starter</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        ></button>

        <!-- <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav me-auto mb-2 mb-md-0">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">Link</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link disabled"
                  href="#"
                  tabindex="-1"
                  aria-disabled="true"
                  >Disabled</a
                >
              </li>
            </ul>
            <form class="d-flex">
              <input
                class="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button class="btn btn-outline-success" type="submit">
                Search
              </button>
            </form>
          </div> -->
        <button
          class="btn drawer-btn"
          type="button"
          @click="showHide.rightDrawer = !showHide.rightDrawer"
        >
          <span class="navbar-toggler-icon"></span>
          <!-- <i class="bi-gear-fill"></i> -->
        </button>
      </div>
    </nav>
    <div
      class="right-drawer card rounded-0 shadow-sm"
      :class="{ open: showHide.rightDrawer }"
    >
      <div class="card-body">
        <button
          class="btn drawer-close-btn"
          type="button"
          @click="showHide.rightDrawer = !showHide.rightDrawer"
        >
          X
        </button>
        <h5 class="card-title">Available Pages</h5>
        <div class="card-text">
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="item in routes" :key="item.name">
              <router-link class="no-text-decoration" :to="item.path || '/'">{{
                item.name
              }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <router-view /> can be commented out and panels writter right here -->
    <div class="route-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
// To simplify development bootstrap js files are installed on the public/index.html file (using CDN)
export default {
  name: "App",
  data() {
    return {
      header: [
        // INSERTS EXTRA SCRIPTS IN <head></head> Just before </head>  See example below.
        // '<link rel="preconnect" href="https://fonts.googleapis.com">',
        // '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>',
        // '<link href="https://fonts.googleapis.com/css2?family=Comforter+Brush&display=swap" rel="stylesheet">',
      ],
      footer: [
        // INSERTS EXTRA SCRIPTS IN <body></body> Just before </body>. See example below.
        '<script src="https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js" integrity="sha512-A7AYk1fGKX6S2SsHywmPkrnzTZHrgiVT7GcQkLGDe2ev0aWb8zejytzS8wjo7PGEXKqJOrjQ4oORtnimIRZBtw==" crossorigin="anonymous" referrerpolicy="no-referrer">',
      ],
      showHide: {
        rightDrawer: false,
      },
    };
  },
  watch: {
    /* eslint-disable */
    $route(to, from) {
      this.showHide.rightDrawer = false;
    },
  },
  computed: {
    routes() {
      let routes = this.$router.getRoutes();
      routes.sort(function(a, b) {
        if (a.name == "Main Page" || b.name == "Main Page") {
          return 0;
        }
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return routes;
    },
  },
  methods: {
    init() {
      this.header.forEach((item) =>
        document.header.insertAdjacentHTML("beforeend", item)
      );
      this.footer.forEach((item) =>
        document.body.insertAdjacentHTML("beforeend", item)
      );
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.showHide.rightDrawer = !this.showHide.rightDrawer;
      }
    });
    this.$nextTick(() => this.init());
  },
};
</script>

<style lang="scss">
// @import "@/scss/custom.scss";
// styles specifically for this starter app
.route-wrapper {
  position: relative;
  overflow: hidden;
  nav.fixed-top:only-of-type {
    // transform: translateY(56px) !important;
    top: 56px !important;
  }
  > div {
    margin-top: 56px !important;
  }
}
.drawer-btn {
  position: fixed;
  right: 0;
  i {
    font-size: 28px;
    color: white;
    transition: opacity 0.25s ease-in-out;
    &:hover {
      opacity: 0.8;
    }
  }
}

.right-drawer {
  $width: 300px;

  position: fixed !important;
  top: 0;
  right: 0;
  z-index: 9999;
  height: 100%;
  width: $width;
  transform: translateX($width);
  transition: all 0.25s ease-in-out;

  .drawer-close-btn {
    position: absolute;
    background: white;
    border-radius: 0;
    padding: 0px 4px;
    left: -20px;
    top: 0px;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
    -webkit-box-shadow: -5px 0px 8px -5px rgba(0, 0, 0, 0.49);
    box-shadow: -5px 0px 8px -5px rgba(0, 0, 0, 0.49);
  }

  &.open {
    transform: translateX(0);

    .drawer-close-btn {
      opacity: 1;
    }
  }
}
</style>
